import React, {useState , useEffect , useContext} from 'react'
import {  useNavigate, useParams, useSearchParams } from "react-router-dom"
import axios from "axios";
import {Helmet} from 'react-helmet'
import { login } from '../../Redux/features/authSlice'
import { updateGeneralUI } from '../../Redux/features/uiReducer'
import { useSelector, useDispatch } from 'react-redux'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { Main , Input, Checkbox, Button } from '../../Components';
import { Card } from '../../Components/Card/Card';

import { ReactComponent as Logo } from './../../assets/logo/logo.svg'

import './reset.css'
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import moment from 'moment'

/**
 * 
 * @returns 
 */
export function ResetPassword() {

	const { token } = useParams()
	const [searchParams] = useSearchParams();

	const [formData, setFormData] = useState({
		password: "",
		password_repeat : ""
		 
	});
	const [response, setResponse] = useState({
		message : "",
		status : "danger"
	})

	const [isLoading, setIsLoading] = useState(false)
	const [sessionToken, setSessionToken] = useState(null)

	const { password, password_repeat } = formData;

	const navigate = useNavigate();
	const dispatch = useDispatch();

	
	// Grab the data from redux 
	const { user } = useSelector((state) => state.auth);

 

	const onChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	/**
	 * 
	 * @param {*} e 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise(async(resolve , reject) => {

			setIsLoading(true)
			// ! Check the password field
			if(!password ||  password ==='' || password.length < 4){
				setResponse({
					message : "Password too short, try a mix of characters and numbers",
					status : 'danger'
				});
				setIsLoading(false)
				return;
			}
			// ! Check the confirm password field
			if(!password_repeat ||  password_repeat ==='' || password_repeat.length < 4){
				setResponse({
					message : "Confirm password too short, try a mix of characters and numbers",
					status : 'danger'
				});
				setIsLoading(false)
				return;
			}

			// ! check if the password and confirm password are equals
			if (password !==password_repeat) {
				setResponse({
					message: "Passwords must be the same!",
					status : 'danger'
				})	
				setIsLoading(false)
				return;
			}
			 
	
			let userData = {
				password,
				token
				 
			};
	
			 
			await axios
				.post(`${process.env.REACT_APP_API_URL}/users/password/reset`, userData , {} )
				.then(res => res.data )
				.then(async response => {
					toast.success(response.message)
					setResponse({
						message : response.message,
						status : 'success'
					});
					setIsLoading(false)
					 
				})
				.catch(error => {
	
					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
								
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}
	
					toast.error(__error)  
					setResponse({
						message : __error,
						status : 'danger'
					});
					reject(__error)
				})
		})



		
	};

 

	return (
		<>
		<Helmet>
			<title>Reset password - {process.env.REACT_APP_APP_NAME}</title>
		</Helmet>
		<Main size={`full`} withNav={false} positionY="top"  >
			<div className="layout-login-form">
				<div className="logo-wrapper">
					<Logo />
				</div> 
				<Card shadow="md" target="login">
					<div className='title'>Reset password</div>
					<p>Enter the password and repeat it to reset your password account</p>
					{
						response.message !=='' && 
						<p className={`alert alert-${response.status} text-${response.status}`}>{response.message}</p> 
					}
					{
						response.status === 'success'
						? <form>
							<div className="field-group submit-fields-group fluid">
							<Button color="purple" ><Link to={`/login`}>Go to Login page</Link></Button>
							</div>
						</form>
						: <form onSubmit={onSubmit}>
							<Input 
								type="password"
								name="password"
								label="Password"
								
								required
								onChange={onChange}
								/>
							<Input 
								type="password"
								name="password_repeat"
								label="Confirm Password"
								
								required
								onChange={onChange}
								/>
							<div className="field-group submit-fields-group fluid">
								<Button onClick={onSubmit} color="purple" loading={isLoading} >Reset your password</Button>
							</div>
						</form>
					}
					

				</Card>
				<div className='under-form'>Already have an account? <Link to={`/login${searchParams.get('invitationid')!==null ? `?invitationid=${searchParams.get('invitationid')}` : ''}`}>Login</Link></div>
			</div>
		</Main>
		</>
	)
}

 